import { createSlice } from "@reduxjs/toolkit";
import { ITrainingHelpSlice } from "../../../models/master/trainingHelp";


const initialTrainingHelpState: ITrainingHelpSlice = {
  trainingHelps:undefined,
  trainingHelp:undefined
};

const trainingHelpSlice = createSlice({
  name: "trainingHelp",
  initialState: initialTrainingHelpState,
  reducers: {
    setTrainingHelps: (state, action: { payload: any }) => {
      state.trainingHelps = action.payload;
    },
    setTrainingHelp: (state, action: { payload: any }) => {
      state.trainingHelp = action.payload;
    },
    
  },
});

export const { setTrainingHelps, setTrainingHelp } =
trainingHelpSlice.actions;

const trainingHelpReducer = trainingHelpSlice.reducer;

export type trainingHelpState = ReturnType<typeof trainingHelpReducer>;

export default trainingHelpReducer;
